"use client";

import styles from "./app-account-setting-header.module.css";

import { publicUrl } from "@/utils/public-url";
interface AppAccountSettingHeaderProps {
  isInFlow?: boolean;
}

export default function AppAccountSettingHeader({ isInFlow = false }: AppAccountSettingHeaderProps) {
  return (
    <header className={`${styles.header} ${isInFlow ? styles.headerInFlow : ""}`}>
      <div className={styles.headerContainer}>
        <img className={styles.logoImg} src={publicUrl("/images/logoSalpha.png")} alt="logo" />
      </div>
    </header>
  );
}
